export default __webpack_public_path__ + "static/media/icosahedron.7ef66166.png";